import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const VidezMarmorja = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Keramične ploščice videz marmorja"
          subtitle="Eleganca marmorja za vaš dom"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Videz marmorja"
            subtitle="Eleganca marmorja za vaš dom"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Naše keramične ploščice z videzom marmorja združujejo klasično eleganco z moderno trpežnostjo. 
              Ustvarite razkošne prostore z brezčasnim videzom marmorja brez njegove občutljivosti in visokih stroškov vzdrževanja.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Marmor ploščice 1" },
              { src: "/placeholder.svg", alt: "Marmor ploščice 2" },
              { src: "/placeholder.svg", alt: "Marmor ploščice 3" },
              { src: "/placeholder.svg", alt: "Marmor ploščice 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VidezMarmorja;